import { Box, CircularProgress, Typography } from '@mui/material'
import Keycloak from 'keycloak-js'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { SSO_RETURN_KEY } from '../router/PrivateRoute'

export const SsoCallback = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const initCalled = useRef(false)

  useEffect(() => {
    if (initCalled.current) return
    initCalled.current = true

    const hostname = window.location.hostname
    //ローカル実行用
    // const tenant = hostname === 'localhost'
    //   ? process.env.REACT_APP_KEYCLOAK_REALM!
    //   : hostname.split('.')[0]
    const tenant = hostname.split('.')[0]

    console.log("hostname: "+hostname);
    console.log("tenant: "+tenant);

    const keycloak = new Keycloak({
      url: process.env.REACT_APP_KEYCLOAK_URL!,
      clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'cotopat-client',
      realm: tenant,
    })

    keycloak
      .init({
        onLoad: 'login-required',
        pkceMethod: 'S256',
        responseMode: 'fragment',
        checkLoginIframe: false,
      })
      .then((authenticated) => {
        if (authenticated && keycloak.token && keycloak.tokenParsed) {
          auth.signInWithKeycloak(keycloak)
          auth.setTenant(tenant)
          const savedPath = sessionStorage.getItem(SSO_RETURN_KEY)
          sessionStorage.removeItem(SSO_RETURN_KEY)
          if (savedPath) {
            navigate(savedPath, { replace: true })
          } else {
            //DCP -> Cotopatへの遷移
            const aud = keycloak.tokenParsed.aud
            const audArray = Array.isArray(aud) ? aud : aud ? [aud] : []
            if (audArray.includes('customer-portal')) {
              navigate('/devicelist', { replace: true })
            } else {
              // provider-portal が aud に含まれる場合、
              // root provider portalでaud に portal 情報が含まれない場合も provider-portal とみなす
              navigate('/customerinfomanagement', { replace: true })
            }
          }
        } else {
          setError('SSO authentication failed')
        }
      })
      .catch((err) => {
        console.error('Keycloak init error:', err)
        setError('SSO initialization failed')
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" mt="200px">
        <Typography color="error">{error}</Typography>
      </Box>
    )
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" mt="200px">
      <CircularProgress />
    </Box>
  )
}
